module.exports = __webpack_public_path__ + "img/location-category-store@2x.e081316.webp";